import { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { clsx } from "clsx";

interface LabelProps {
  htmlFor?: string;
  children: ReactNode;
  className?: string;
  theme?: "light" | "dark"; // NOVO
}

const Label: FC<LabelProps> = ({ htmlFor, children, className, theme }) => {
  let baseClasses = "mb-1.5 block text-sm font-medium ";
  if (theme === "light") {
    baseClasses += "text-gray-700 ";
  } else if (theme === "dark") {
    baseClasses += "text-gray-400 ";
  } else {
    baseClasses += "text-gray-700 dark:text-gray-400 ";
  }

  return (
    <label
      htmlFor={htmlFor}
      className={clsx(
        twMerge(
          baseClasses,
          className,
        ),
      )}
    >
      {children}
    </label>
  );
};

export default Label;
